document.addEventListener('DOMContentLoaded', function() {
    const quizI18n = window.cbThemeI18n?.quiz || {};
    const quiz = document.querySelector('[data-quiz]');

    if (!quiz) {
        return;
    }

    const questions = Array.from(quiz.querySelectorAll('[data-quiz-question]'));
    const summary = quiz.querySelector('[data-quiz-summary]');
    const scoreNode = quiz.querySelector('[data-quiz-score]');
    const titleNode = quiz.querySelector('[data-quiz-title]');
    const descriptionNode = quiz.querySelector('[data-quiz-description]');
    const legend = quiz.querySelector('[data-quiz-legend]');
    const riskRules = {
        low: {
            title: quizI18n.lowTitle,
            description: quizI18n.lowDescription
        },
        moderate: {
            title: quizI18n.moderateTitle,
            description: quizI18n.moderateDescription
        },
        high: {
            title: quizI18n.highTitle,
            description: quizI18n.highDescription
        }
    };

    const highlightLegend = function(riskLevel) {
        if (!legend) {
            return;
        }

        legend.classList.remove('is-risk-low', 'is-risk-moderate', 'is-risk-high');
        legend.classList.add('is-risk-' + riskLevel);

        const legendItems = legend.querySelectorAll('.quiz-legend__item--low, .quiz-legend__item--moderate, .quiz-legend__item--high');
        legendItems.forEach(function(item) {
            item.classList.remove('is-active');
        });

        const activeLegendItem = legend.querySelector('.quiz-legend__item--' + riskLevel);
        if (activeLegendItem) {
            activeLegendItem.classList.add('is-active');
        }
    };

    const renderValidationState = function(question) {
        question.classList.add('is-unanswered');
        const questionHeading = question.querySelector('h2, h3, h4, h5, h6, p');
        if (questionHeading) {
            questionHeading.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
            question.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    const getSelections = function() {
        return questions.map(function(question) {
            return {
                node: question,
                answer: question.dataset.quizValue || '',
                number: Number.parseInt(question.dataset.quizQuestionNumber || '0', 10),
                group: question.dataset.quizGroup || ''
            };
        });
    };

    const renderSummary = function() {
        const selections = getSelections();
        const firstUnanswered = selections.find(function(selection) {
            return !selection.answer;
        });

        if (firstUnanswered) {
            summary.hidden = true;
            summary.removeAttribute('data-risk-level');
            return false;
        }

        const yesAnswers = selections.filter(function(selection) {
            return selection.answer === 'yes';
        });
        const stopYesCount = yesAnswers.filter(function(selection) {
            return selection.group === 'stop';
        }).length;
        const totalYesCount = yesAnswers.length;
        const highRiskQuestions = [5, 7, 8, 9, 10];
        const hasAdditionalHighRiskFactor = yesAnswers.some(function(selection) {
            return highRiskQuestions.includes(selection.number);
        });

        let riskLevel = 'low';

        if (totalYesCount >= 5 || (stopYesCount >= 2 && hasAdditionalHighRiskFactor)) {
            riskLevel = 'high';
        } else if (totalYesCount >= 3) {
            riskLevel = 'moderate';
        }

        summary.hidden = false;
        summary.dataset.riskLevel = riskLevel;
        scoreNode.textContent = quizI18n.score.replace('%1$d', totalYesCount);
        titleNode.textContent = riskRules[riskLevel].title;
        descriptionNode.textContent = riskRules[riskLevel].description;
        highlightLegend(riskLevel);

        return true;
    };

    questions.forEach(function(question) {
        const answers = question.querySelectorAll('[data-quiz-answer]');

        answers.forEach(function(answerButton) {
            answerButton.addEventListener('click', function() {
                const wasComplete = !summary.hidden;
                const selectedValue = answerButton.dataset.quizAnswer;
                question.dataset.quizValue = selectedValue;
                question.classList.remove('is-unanswered');

                answers.forEach(function(button) {
                    const isActive = button === answerButton;
                    button.classList.toggle('is-active', isActive);
                    button.setAttribute('aria-pressed', String(isActive));
                });

                const isComplete = renderSummary();
                if (isComplete && !wasComplete) {
                    summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    summary.focus({ preventScroll: true });
                }
            });
        });
    });

    renderSummary();
});
